<template>
    <aside class="menu">
        <p class="menu-label aside-title">
            Profit
        </p>
        <p class="menu-label">
            Select Client
        </p>
        <profit-client-select></profit-client-select>
        <p class="menu-label">
            Select Market
        </p>
        <profit-market-select></profit-market-select>
        <p class="menu-label" v-if="!isSalesStaff">
            Sales Person
        </p>
        <profit-sales-person-select v-if="!isSalesStaff"></profit-sales-person-select>
        <p class="menu-label">
            Select Date From
        </p>
        <datetime
                input-class="input"
                v-model="date_from"
                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                type="date"
                value-zone="local"
                zone="local"
                placeholder="Date from:"
        ></datetime>
        <p class="menu-label">
            Select Date To
        </p>
        <datetime
                input-class="input"
                v-model="date_to"
                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                type="date"
                value-zone="local"
                zone="local"
                placeholder="Date to:"
        ></datetime>
        <p class="menu-label">
            PREFORM SEARCH
        </p>
        <profit-search-button></profit-search-button>
        <p class="menu-label">
            CLEAR FORM
        </p>
        <profit-clear-button></profit-clear-button>
        <p class="menu-label">
            Download Excel
        </p>
        <profit-excel-button></profit-excel-button>
    </aside>
</template>

<script>
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import ProfitClientSelect from './ProfitClientSelect'
    import ProfitMarketSelect from './ProfitMarketSelect'
    import ProfitSalesPersonSelect from './ProfitSalesPersonSelect'
    import ProfitSearchButton from './ProfitSearchButton'
    import ProfitClearButton from './ProfitClearButton'
    import ProfitExcelButton from './ProfitExcelButton'
    export default {
        components: {
            Datetime,
            ProfitClientSelect,
            ProfitMarketSelect,
            ProfitSalesPersonSelect,
            ProfitSearchButton,
            ProfitClearButton,
            ProfitExcelButton
        },
        computed: {
            date_from: {
                get() {
                    return this.$store.getters.getProfitSectionData.date_from
                },
                set(value) {
                    this.$store.dispatch('setProfitSectionFieldValue', { field: 'date_from', value: value })
                }
            },
            date_to: {
                get() {
                    return this.$store.getters.getProfitSectionData.date_to
                },
                set(value) {
                    this.$store.dispatch('setProfitSectionFieldValue', { field: 'date_to', value: value })
                }
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        }
    }
</script>

<style scoped>
    .aside-title {
        color: #4a4a4a;
        font-size: larger;
        font-weight: bold;
        text-align: center;
    }
    .menu-label {
        text-align: center;
    }
    .input {
        height: 1em;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitSideBar.vue